import { render, staticRenderFns } from "./AddDelivery.vue?vue&type=template&id=6babed30"
import script from "./AddDelivery.vue?vue&type=script&lang=js"
export * from "./AddDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports